export * from './DeleteAccountModalContentContainer'



// WEBPACK FOOTER //
// ./src/components/DeleteAccountModalContent/index.js